module.exports = __webpack_public_path__ + "static/media/jql.3b8c2e33.7dd297c8.jpg";